import React, { useState } from 'react';
import type { ModalSize } from '@types';
import { Dropdown } from '@components/Dropdown';
import Input from '@components/Input';
import Tabbar from '@components/Tabbar';
import {
  correctingModalSizeValue,
  defaultModalSize,
  modalSizeSuffixItems,
} from '../constants';

type Props = {
  currentModalSize?: ModalSize;
  onChange: (k: ModalSize) => void;
};
export default function ModalSizeSetting({
  currentModalSize,
  onChange,
}: Props) {
  const [modalSize, setModalSize] = useState<ModalSize>(
    currentModalSize ?? defaultModalSize
  );
  const [activeModalSize, setActiveModalSize] = useState<number>(0);
  return (
    <>
      <Tabbar
        className="mt-25"
        tabs={['桌面端尺寸', '移动端尺寸']}
        activeIndex={activeModalSize}
        onChange={(index) => {
          setActiveModalSize(index);
        }}
      />
      {activeModalSize === 0 && (
        <>
          <div className="ml-10 mt-20 flex items-center justify-between">
            <div className="mr-10">宽</div>
            <Input
              scheme="dark"
              className="h-30 w-100"
              placeholder="请输入宽度"
              value={modalSize.pc.width.replace('%', '').replace('px', '')}
              onBlur={(e) => {
                const val = correctingModalSizeValue(
                  e.target.value,
                  activeModalSize,
                  modalSize.pc.width,
                  true,
                  true
                );
                const size = {
                  mobile: modalSize.mobile,
                  pc: {
                    width: `${val}${
                      modalSize.pc.width.endsWith('%') ? '%' : 'px'
                    }`,
                    height: modalSize.pc.height,
                  },
                };
                setModalSize(size);
                onChange(size);
              }}
              onChange={(e) => {
                const val = correctingModalSizeValue(
                  e.target.value,
                  activeModalSize,
                  modalSize.pc.width,
                  true
                );
                const size = {
                  mobile: modalSize.mobile,
                  pc: {
                    width: `${val}${
                      modalSize.pc.width.endsWith('%') ? '%' : 'px'
                    }`,
                    height: modalSize.pc.height,
                  },
                };
                setModalSize(size);
                onChange(size);
              }}
            />
            <Dropdown
              className="ml-10 w-70"
              items={modalSizeSuffixItems}
              onChange={(id) => {
                const size = {
                  mobile: modalSize.mobile,
                  pc: {
                    width: id === '%' ? '90%' : '1200px',
                    height: modalSize.pc.height,
                  },
                };
                setModalSize(size);
                onChange(size);
              }}
              selected={modalSize.pc.width.endsWith('%') ? '%' : 'px'}
            />
          </div>
          <div className="ml-10 mt-20 flex items-center justify-between">
            <div className="mr-10">高</div>
            <Input
              scheme="dark"
              className="h-30 w-100"
              placeholder="请输入高度"
              value={modalSize.pc.height.replace('%', '').replace('px', '')}
              onBlur={(e) => {
                const val = correctingModalSizeValue(
                  e.target.value,
                  activeModalSize,
                  modalSize.pc.height,
                  false,
                  true
                );
                const size = {
                  mobile: modalSize.mobile,
                  pc: {
                    height: `${val}${
                      modalSize.pc.height.endsWith('%') ? '%' : 'px'
                    }`,
                    width: modalSize.pc.width,
                  },
                };
                setModalSize(size);
                onChange(size);
              }}
              onChange={(e) => {
                const val = correctingModalSizeValue(
                  e.target.value,
                  activeModalSize,
                  modalSize.pc.height,
                  false
                );
                const size = {
                  mobile: modalSize.mobile,
                  pc: {
                    height: `${val}${
                      modalSize.pc.height.endsWith('%') ? '%' : 'px'
                    }`,
                    width: modalSize.pc.width,
                  },
                };
                setModalSize(size);
                onChange(size);
              }}
            />
            <Dropdown
              className="ml-10 w-70"
              items={modalSizeSuffixItems}
              onChange={(id) => {
                const size = {
                  mobile: modalSize.mobile,
                  pc: {
                    height: id === '%' ? '90%' : '700px',
                    width: modalSize.pc.width,
                  },
                };
                setModalSize(size);
                onChange(size);
              }}
              selected={modalSize.pc.height.endsWith('%') ? '%' : 'px'}
            />
          </div>
        </>
      )}
      {activeModalSize === 1 && (
        <div className="ml-10 mt-20 flex items-center justify-between">
          <div className="mr-10">高</div>
          <Input
            scheme="dark"
            className="h-30 w-100"
            placeholder="请输入高度"
            value={modalSize.mobile.height.replace('%', '').replace('px', '')}
            onBlur={(e) => {
              const val = correctingModalSizeValue(
                e.target.value,
                activeModalSize,
                modalSize.mobile.height,
                false,
                true
              );
              const size = {
                pc: modalSize.pc,
                mobile: {
                  height: `${val}${
                    modalSize.mobile.height.endsWith('%') ? '%' : 'px'
                  }`,
                  width: modalSize.mobile.width,
                },
              };
              setModalSize(size);
              onChange(size);
            }}
            onChange={(e) => {
              const val = correctingModalSizeValue(
                e.target.value,
                activeModalSize,
                modalSize.mobile.height,
                false
              );
              const size = {
                pc: modalSize.pc,
                mobile: {
                  height: `${val}${
                    modalSize.mobile.height.endsWith('%') ? '%' : 'px'
                  }`,
                  width: modalSize.mobile.width,
                },
              };
              setModalSize(size);
              onChange(size);
            }}
          />
          <Dropdown
            className="ml-10 w-70"
            items={modalSizeSuffixItems}
            onChange={(id) => {
              const size = {
                pc: modalSize.pc,
                mobile: {
                  height: id === '%' ? '90%' : '700px',
                  width: modalSize.mobile.width,
                },
              };
              setModalSize(size);
              onChange(size);
            }}
            selected={modalSize.mobile.height.endsWith('%') ? '%' : 'px'}
          />
        </div>
      )}
      {activeModalSize === 0 && (
        <>
          <div className="mt-10 text-sm text-orange">
            选择百分比（％）时，弹窗尺寸以相对宽高比例进行显示
          </div>
          <div className="text-sm text-orange">
            选择绝对值（px）时，则以绝对宽高尺寸进行显示
          </div>
        </>
      )}
      {activeModalSize === 1 && (
        <>
          <div className="mt-10 text-sm text-orange">
            移动端中宽度始终以100%显示
          </div>
          <div className="text-sm text-orange">
            高度则从下往上显示百分比或绝对值
          </div>
        </>
      )}
    </>
  );
}
